<div class="model-container">
  <svg
    fill="none"
    height="258"
    width="482"
    viewBox="0 0 482 258"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="body">
      <path
        [attr.fill]="bodyColor"
        d="M252.894 57.3846V53.1932H265.18V52.2175C260.397 45.7449 252.894 46.7893 252.894 46.7893C252.894 13.423 240.993 1 240.993 1C240.993 1 229.092 13.423 229.092 46.7893C229.092 46.7893 221.589 45.7587 216.807 52.2175V53.1932H229.092V79.4685H224.269C222.647 79.4685 221.342 80.774 221.342 82.3956C221.342 84.0172 222.647 85.3227 224.269 85.3227H229.092V90.4898C229.092 94.1178 234.782 101.621 235.043 113.769C235.139 118.455 235.414 127.209 235.73 137.021H246.284H246.256C246.572 127.209 246.834 118.455 246.944 113.769C247.205 101.621 252.894 94.1041 252.894 90.4898V85.3227H257.717C259.339 85.3227 260.645 84.0172 260.645 82.3956C260.645 80.774 259.325 79.4685 257.717 79.4685H252.894V57.3709V57.3846Z"
      />
      <path
        d="M229.092 86.6963C232.198 87.672 235.812 91.9321 237.434 96.8518C237.874 98.1711 238.176 99.188 238.382 99.9714C238.712 101.236 237.75 102.472 236.431 102.472H233.27"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        d="M252.894 86.6963C249.788 87.672 246.174 91.9321 244.553 96.8518C244.113 98.1711 243.81 99.188 243.604 99.9714C243.274 101.236 244.236 102.472 245.556 102.472H248.716"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        d="M257.731 79.4824H224.269C222.652 79.4824 221.342 80.7929 221.342 82.4095V82.4233C221.342 84.0399 222.652 85.3504 224.269 85.3504H257.731C259.348 85.3504 260.659 84.0399 260.659 82.4233V82.4095C260.659 80.7929 259.348 79.4824 257.731 79.4824Z"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M229.092 85.3369V90.504C229.092 94.132 234.782 101.635 235.043 113.783C235.139 118.47 235.414 127.223 235.73 137.035H246.284H246.256C246.572 127.223 246.834 118.47 246.944 113.783C247.205 101.635 252.894 94.1182 252.894 90.504V85.3369"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M231.112 56.4072C230.288 56.4072 229.573 56.792 229.092 57.3829V60.6811C229.573 61.272 230.302 61.6568 231.112 61.6568C232.555 61.6568 233.737 60.4887 233.737 59.032C233.737 57.5753 232.569 56.4072 231.112 56.4072Z"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        d="M250.874 56.4072C251.699 56.4072 252.413 56.792 252.894 57.3829V60.6811C252.413 61.272 251.685 61.6568 250.874 61.6568C249.431 61.6568 248.249 60.4887 248.249 59.032C248.249 57.5753 249.417 56.4072 250.874 56.4072Z"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        d="M250.572 56.4493V43.3254C250.572 41.7588 249.458 40.3983 247.919 40.0823C243.302 39.134 238.684 39.134 234.067 40.0823C232.528 40.3983 231.415 41.7451 231.415 43.3254V56.4493C232.72 56.6005 233.737 57.6999 233.737 59.0466C233.737 60.3934 232.72 61.4928 231.415 61.6439V72.7889C231.415 74.6029 232.885 76.0733 234.699 76.0733H247.273C249.087 76.0733 250.558 74.6029 250.558 72.7889V61.6439C249.252 61.4928 248.235 60.3934 248.235 59.0466C248.235 57.6999 249.252 56.6005 250.558 56.4493H250.572Z"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        d="M240.993 10.7139V28.304"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        d="M243.261 28.3047H238.74V39.381H243.261V28.3047Z"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        d="M240.993 1.0127C240.993 1.0127 229.092 13.4357 229.092 46.802V79.4812"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M240.993 1.0127C240.993 1.0127 252.894 13.4357 252.894 46.802C252.894 63.1966 252.894 73.1598 252.894 79.4812"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M229.092 46.8015C229.092 46.8015 221.589 45.7709 216.807 52.2297V53.2054H229.092"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M252.894 46.8015C252.894 46.8015 260.397 45.7709 265.179 52.2297V53.2054H252.894"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <g id="wing-right">
      <path
        [attr.fill]="wingRightColor"
        d="M480.961 79.9494C480.453 76.9399 478.419 72.1438 470.957 68.6533C459.317 63.2251 424.013 63.2251 395.676 62.8265C387.046 62.7029 370.445 62.6616 351.509 62.6616C351.783 60.6415 351.962 58.91 351.962 57.6594V29.7214H348.733V26.9179C348.733 25.4338 348.183 24.0046 347.18 22.9052L345.105 20.6377L343.03 22.9052C342.026 24.0046 341.477 25.4338 341.477 26.9179V29.7214H338.247V57.6594C338.247 58.91 338.412 60.6415 338.701 62.6616C298.161 62.6754 253.073 62.8265 252.894 62.8265V79.4685H257.717C259.339 79.4685 260.645 80.774 260.645 82.3956C260.645 84.0172 259.325 85.3227 257.717 85.3227H252.894V90.4898C252.894 90.4898 252.894 90.5585 252.894 90.586V90.9433L252.853 90.9983C252.578 93.3207 250.53 96.9624 248.922 102.116C256.068 102.02 291.991 101.484 317.043 100.316C327.295 99.8346 340.982 98.9001 354.752 97.8419C357.17 97.6495 359.589 97.4709 361.98 97.2785L362.338 97.251C363.657 97.1411 364.99 97.0449 366.295 96.9349H366.515C381.522 95.6981 395.443 94.4338 403.702 93.5956C421.553 91.7816 454.15 86.0923 460.87 85.0616C465.831 84.3058 474.433 83.3988 478.625 82.9728C480.137 82.8216 481.222 81.4336 480.961 79.922V79.9494Z"
      />
      <path
        [attr.fill]="wingRightColor"
        d="M460.87 85.0903V80.4316C460.87 80.4316 407.715 85.159 389.864 86.6981C372.012 88.251 354.752 89.4191 354.752 89.4191V97.8844"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        [attr.fill]="wingRightColor"
        d="M364.248 62.8398V82.7112"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        [attr.fill]="wingRightColor"
        d="M366.515 96.948V82.7109H361.98V97.3053"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        [attr.fill]="wingRightColor"
        d="M480.961 79.948C480.453 76.9384 478.419 72.1423 470.957 68.6518C459.317 63.2236 424.013 63.2236 395.676 62.8251C387.046 62.7014 370.446 62.6602 351.509 62.6602C350.382 70.7956 347.441 83.4797 346.534 87.3138C346.383 87.9735 345.778 88.4407 345.105 88.4407C344.431 88.4407 343.827 87.9735 343.676 87.3138C342.769 83.4797 339.841 70.7956 338.701 62.6602C298.079 62.6739 252.88 62.8251 252.88 62.8251V79.467H257.717C259.339 79.467 260.645 80.7725 260.645 82.3941C260.645 84.0157 259.325 85.3212 257.717 85.3212H252.88V90.9418L251.753 94.5698L249.005 102.142C249.005 102.142 289.105 101.62 317.043 100.328C341.6 99.1872 385.851 95.408 403.702 93.6078C421.553 91.8076 454.15 86.1045 460.87 85.0738C465.831 84.318 474.434 83.411 478.625 82.985C480.137 82.8338 481.222 81.4459 480.961 79.9342V79.948Z"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        [attr.fill]="wingRightColor"
        d="M345.105 29.7207H351.962V57.6588C351.962 63.9528 347.675 82.5323 346.534 87.3147C346.383 87.9743 345.778 88.4415 345.105 88.4415C344.418 88.4415 343.827 87.9743 343.676 87.3147C342.549 82.5323 338.247 63.9528 338.247 57.6588V29.7207H345.105Z"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        [attr.fill]="wingRightColor"
        d="M341.49 29.1707V26.9169C341.49 25.4328 342.04 24.0036 343.043 22.9042L345.118 20.6367L347.194 22.9042C348.197 24.0036 348.746 25.4328 348.746 26.9169V29.1707"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <g id="wing-left">
      <path
        [attr.fill]="wingLeftColor"
        d="M229.147 91.0256L229.106 90.9706V90.6133C229.106 90.6133 229.106 90.5446 229.106 90.5171V85.35H224.282C223.472 85.35 222.743 85.0202 222.207 84.498C221.946 84.2369 221.726 83.9208 221.575 83.5635C221.424 83.2062 221.341 82.8215 221.341 82.4229C221.341 82.0244 221.424 81.6259 221.575 81.2823C221.726 80.925 221.932 80.6227 222.207 80.3478C222.743 79.8119 223.472 79.4958 224.282 79.4958H229.106V62.8539C228.927 62.8539 183.839 62.7027 143.299 62.689C143.574 60.6689 143.752 58.9373 143.752 57.6868V29.7487H140.523V26.9453C140.523 25.4611 139.973 24.0319 138.97 22.9325L136.895 20.665L134.82 22.9325C133.817 24.0319 133.267 25.4611 133.267 26.9453V29.7487H130.038V57.6868C130.038 58.9373 130.216 60.6826 130.491 62.7027C111.554 62.7027 94.9536 62.7577 86.3234 62.8676C58.0005 63.2524 22.6828 63.2524 11.0431 68.6944C3.58105 72.1712 1.54719 76.981 1.03872 79.9905C0.791359 81.4885 1.86326 82.8902 3.37491 83.0413C7.56631 83.4673 16.169 84.3606 21.13 85.1302C27.8499 86.1608 60.4467 91.8501 78.2979 93.6641C86.557 94.5024 100.478 95.7667 115.485 96.9898L115.691 97.0035C117.01 97.1134 118.329 97.2234 119.662 97.3196L120.02 97.3471C122.424 97.5395 124.843 97.7318 127.248 97.9105C141.018 98.9687 154.705 99.9031 164.957 100.384C190.009 101.538 225.945 102.074 233.077 102.184C231.47 97.031 229.422 93.3893 229.147 91.0668V91.0256Z"
      />
      <path
        [attr.fill]="wingLeftColor"
        d="M21.1299 85.0903V80.4316C21.1299 80.4316 74.2851 85.159 92.1363 86.6981C109.988 88.2373 127.248 89.4191 127.248 89.4191V97.8844"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        [attr.fill]="wingLeftColor"
        d="M117.738 62.8398V82.7112"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        [attr.fill]="wingLeftColor"
        d="M115.485 96.948V82.7109H120.006V97.3053"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
      />
      <path
        [attr.fill]="wingLeftColor"
        d="M1.03885 79.948C1.54732 76.9384 3.58118 72.1423 11.0432 68.6518C22.683 63.2236 57.9869 63.2236 86.3236 62.8251C94.9537 62.7014 111.554 62.6602 130.491 62.6602C131.618 70.7956 134.559 83.4797 135.466 87.3138C135.617 87.9735 136.222 88.4407 136.895 88.4407C137.569 88.4407 138.173 87.9735 138.324 87.3138C139.231 83.4797 142.159 70.7956 143.299 62.6602C183.921 62.6739 229.12 62.8251 229.12 62.8251V79.467H224.282C222.661 79.467 221.355 80.7725 221.355 82.3941C221.355 84.0157 222.675 85.3212 224.282 85.3212H229.12V90.9418L230.247 94.5698L232.995 102.142C232.995 102.142 192.895 101.62 164.957 100.328C140.399 99.1872 96.1493 95.408 78.2981 93.6078C60.4468 91.7938 27.8501 86.1045 21.1301 85.0738C16.1691 84.318 7.56644 83.411 3.37504 82.985C1.86339 82.8338 0.777746 81.4459 1.03885 79.9342V79.948Z"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        [attr.fill]="wingLeftColor"
        d="M136.881 29.7207H130.024C130.024 29.7207 130.024 50.4166 130.024 57.6588C130.024 63.9528 134.312 82.5323 135.452 87.3147C135.603 87.9743 136.208 88.4415 136.881 88.4415C137.568 88.4415 138.159 87.9743 138.311 87.3147C139.437 82.5323 143.739 63.9528 143.739 57.6588V29.7207H136.881Z"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        [attr.fill]="wingLeftColor"
        d="M140.509 29.1707V26.9169C140.509 25.4328 139.96 24.0036 138.956 22.9042L136.881 20.6367L134.806 22.9042C133.803 24.0036 133.253 25.4328 133.253 26.9169V29.1707"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <g id="tail">
      <path
        [attr.fill]="tailColor"
        d="M290.149 201.748C289.764 200.002 287.332 195.783 280.832 192.045C273.122 187.62 255.903 187.236 244.209 187.194H244.552L244.607 185.449C244.607 185.449 245.555 158.665 246.256 137.049H235.73C236.43 158.665 237.379 185.449 237.379 185.449L237.434 187.194H239C227.306 187.208 209.125 187.456 201.154 192.045C194.668 195.77 192.235 200.002 191.837 201.748C191.438 203.493 194.75 205.43 200.755 206.021C206.17 206.544 228.144 207.066 238.107 207.162L238.396 215.325H238.423C236.98 215.325 235.798 216.493 235.798 217.95V233.973C235.798 236.653 239.041 244.555 239.894 246.589C240.017 246.877 240.457 247.07 240.979 247.07C241.501 247.07 241.941 246.877 242.065 246.589C242.917 244.555 246.16 236.653 246.16 233.973V217.95C246.16 216.507 244.992 215.325 243.535 215.325H243.563L243.851 207.162C253.828 207.066 275.802 206.544 281.203 206.021C287.222 205.444 290.52 203.493 290.122 201.748H290.149Z"
      />
      <path
        d="M238.121 207.176L238.41 215.325H240.993"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M243.865 207.162L243.577 215.325H240.993"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M240.993 187.194C229.477 187.194 209.592 187.194 201.154 192.045C194.668 195.77 192.235 200.002 191.837 201.747C191.438 203.493 194.75 205.43 200.756 206.021C206.761 206.612 233.284 207.189 240.979 207.189"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M240.993 187.194C252.509 187.194 272.394 187.194 280.832 192.045C287.318 195.77 289.751 200.002 290.149 201.747C290.548 203.493 287.236 205.43 281.231 206.021C275.225 206.612 248.703 207.189 241.007 207.189"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M243.673 212.604H266.54"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M215.488 212.604H238.341"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M240.993 215.325H238.437C236.994 215.325 235.812 216.493 235.812 217.95V233.974C235.812 236.653 239.055 244.555 239.907 246.589C240.031 246.878 240.471 247.07 240.993 247.07C241.515 247.07 241.955 246.878 242.079 246.589C242.931 244.555 246.174 236.653 246.174 233.974V217.95C246.174 216.507 245.006 215.325 243.549 215.325H240.993Z"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M237.434 187.194L237.379 185.449C237.379 185.449 236.431 158.665 235.73 137.049H246.256C245.555 158.665 244.607 185.449 244.607 185.449L244.552 187.194"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        d="M240.993 199.261C239.138 199.261 237.558 197.9 237.269 196.072L236.596 191.702C236.486 190.988 237.035 190.342 237.764 190.342H244.209C244.937 190.342 245.487 190.988 245.377 191.702L244.704 196.072C244.415 197.914 242.835 199.261 240.979 199.261H240.993Z"
        stroke="#969696"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
        style="visibility: visible"
      />
      <path
        d="M240.993 247.069V256.84"
        stroke="#5C5C5C"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
  </svg>
</div>
<ng-container *ngFor="let part of validParts">
  <app-drone-model-vector-table
    [part]="part"
    modelType="vector"
  ></app-drone-model-vector-table>
</ng-container>
